import $ from 'jquery';
import Swiper from 'swiper';
import { updateTreesCounter } from './donationToTrees';

const selectFormatElements = document.querySelectorAll('.calendar-page-choose-format');
const selectedCalendarFormatRadioElement = document.querySelector('.calendar-page-choose-format:checked');
const showPriceElement = document.querySelector('.js-show-price');
const showPriceOriginalElement = document.querySelector('.js-show-price-original');
const showPriceElement2 = document.querySelector('.js-show-price-2');
let price;
let originalprice;
let donation;
let availability;

// Add a check icon to each calendar format box
for (const input of selectFormatElements) {
    const box = input.closest('.c-calendar-format__item')
        ?.querySelector('.o-radio__box');

    if (box && !box.querySelector('.format-check-icon')) {
        box.insertAdjacentHTML(
            'beforeend',
            `<i data-lucide="circle-check" class="format-check-icon"></i>`
        );
    }
}

// Initialize Lucide icons
if (window.lucide) {
    window.lucide.createIcons();
}


const updateValues = function () {
  updateTreesCounter(donation);
  if(showPriceElement != null) {
    showPriceElement.textContent = price;
    showPriceOriginalElement.textContent = originalprice;
    showPriceElement.classList.remove('is-hidden');
  }

  if(showPriceElement2 != null) {
    showPriceElement2.textContent = price;
    showPriceElement2.classList.remove('is-hidden');
  }

  // quick and dirty solution, should be changed properly
  $(".format-stock-block").hide();
  let selectedOption = $('input[name="calendar-format"]:checked').val();
  //$("#stock-"+selectedOption+"-calendar").show();
};

const changeFormat = (event) => {
  ({ price, donation, availability, originalprice } = event.currentTarget.dataset);
  if( availability == 1)
  {
    $(event.currentTarget).prop('checked', true);
    updateValues();
  }
  else
  {
    $(event.currentTarget).prop('checked', false);
    return false;
  }

  $(".format-stock-block").hide();
  //$("#stock-" + event.currentTarget.id).show();


};

for (const selectFormatElement of selectFormatElements) {
  selectFormatElement.addEventListener('change', changeFormat);
}


window.onload = () => {

$('#submit-to-cart-button').click(function (e) {
  if ($(this).hasClass('is-inactive')) {
    return false;
  }
  track_addToCartCalendarItem(price); 
  e.preventDefault();
  $('#submit-to-cart').submit();
});


const mySwiper = new Swiper('.swiper-container', {
  on: {
    slideChange: function () {
      $('.bestseller-icon').toggle(this.activeIndex === 0);
    }
  }
});

  $(".swiper-button-prev").click(function() {
    mySwiper.slidePrev();
  })

  $(".swiper-button-next").click(function() {
    mySwiper.slideNext();
  })

  $('.js-slide-to').click(function () {
    const slide = $(this).data('slide');
    mySwiper.slideTo(slide);
  });

  if( document.querySelector('.postcard-set-price') )
    ({ donation } = document.querySelector('.postcard-set-price').dataset);
  else 
    ({ donation } = document.querySelector('.a3-calendar').dataset);

  console.log(donation);

  updateTreesCounter(donation);

  ({ price, donation, availability, originalprice } = selectedCalendarFormatRadioElement.dataset);
  updateValues();



};

